/**
 * Created by Jerker Nord on 2020-04-08.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BonusBunniesGameConfig} from "../BonusBunniesGameConfig";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {TimelineLite, TweenLite} from "gsap";
import {BonusBunniesGameModuleConfig} from "../BonusBunniesGameModuleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesSoundConfig} from "../BonusBunniesSoundConfig";

export class BonusBunniesBonusSpinsChestView extends BaseView {

    private _layer:ScalableLayer;
    private _chestContainer:PIXI.Container;
    private _chestAnimation:PIXI.spine.Spine;
    private _extraReelActivated:boolean = false;
    private _extraRowActivated:boolean = false;
    private _orientation:string;
    private _chestAnimationActivated:boolean = false;
    private static CHEST_CONTAINER_LANDSCAPE_POSITION:PIXI.Point = new PIXI.Point(776, 260);
    private static CHEST_CONTAINER_PORTRAIT_POSITION:PIXI.Point = new PIXI.Point(410, 6);
    private static CHEST_CONTAINER_EXTRA_REEL_OFFSET:number = 150;
    private static CHEST_INFO_LANDSCAPE_OFFSET:PIXI.Point = new PIXI.Point(-86, 53);
    private static CHEST_INFO_PORTRAIT_OFFSET:PIXI.Point = new PIXI.Point(-155, -150);
    private _rumbleChestLooping:boolean = false;
    private _chestInfoPortraitContainer:PIXI.Container;
    private _chestInfoLandscapeContainer:PIXI.Container;
    private _chestInfoPortrait:PIXI.Sprite;
    private _chestInfoLandscape:PIXI.Sprite;

    constructor() {
        super();
        this._layer = StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
        this._layer.addChild(this);
        this._chestContainer = new PIXI.Container();
        this._chestContainer.visible = false;
        this._chestInfoPortraitContainer = new PIXI.Container();
        this._chestInfoPortraitContainer.scale.set(2, 2);
        this._chestInfoLandscapeContainer = new PIXI.Container();
        this._chestInfoLandscapeContainer.scale.set(2, 2);
        this.addChild(this._chestContainer);
    }

    public rumbleChest():void {
        if(this._chestContainer.visible == true) {
            this._chestAnimation.state.setAnimation(0, "rumble", false);
        }
    }

    public loopRumbleChest():void {
        this._rumbleChestLooping = true;
        this._chestAnimation.state.setAnimation(0, "rumble", true);
    }

    public stopLoopingRumbleChest():void {
        if(this._rumbleChestLooping == true) {
            this._rumbleChestLooping = false;
            this._chestAnimation.skeleton.setSkin(null);
            this._chestAnimation.skeleton.setSkinByName("default");
            this._chestAnimation.skeleton.setSlotsToSetupPose();
            this._chestAnimation.state.setAnimation(0, "base", true);
        }
    }

    protected initAnimations():void {
        this._chestAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset("BonusSpinsChest"));
        this._chestAnimation.skeleton.setSkin(null);
        this._chestAnimation.skeleton.setSkinByName("default");
        this._chestAnimation.skeleton.setSlotsToSetupPose();
        this._chestAnimation.state.setAnimation(0, "base", true);
        this._chestContainer.addChild(this._chestAnimation);
        this._chestInfoPortrait = new PIXI.Sprite(GameResources.getTextures("chestInfoPortrait")[0]);
        this._chestInfoPortrait.position = BonusBunniesBonusSpinsChestView.CHEST_INFO_PORTRAIT_OFFSET;
        this._chestInfoPortraitContainer.addChild(this._chestInfoPortrait);
        this._chestInfoLandscape = new PIXI.Sprite(GameResources.getTextures("chestInfoLandscape")[0]);
        this._chestInfoLandscape.position = BonusBunniesBonusSpinsChestView.CHEST_INFO_LANDSCAPE_OFFSET;
        this._chestInfoLandscapeContainer.addChild(this._chestInfoLandscape);
        this._chestContainer.addChild(this._chestInfoPortraitContainer);
        this._chestContainer.addChild(this._chestInfoLandscapeContainer);
    }

    protected onResize(resizeData:IResizeData):void {
        this._resizeData = resizeData;
        if(this._chestAnimationActivated == false) {
            this._orientation = resizeData.orientation;
            this.setChestPosition(resizeData.orientation);
        }
    }

    private getChestTargetXPosition():number {
        let targetXPos:number = 360;
        if(this._extraReelActivated) {
            targetXPos += (BonusBunniesGameConfig.instance.SYMBOL_WIDTH / 2);
        }
        return targetXPos;
    }

    private getChestTargetYPosition():number {
        let targetYPos:number = 360;
        if(this._extraRowActivated) {
            targetYPos += (BonusBunniesGameConfig.instance.SYMBOL_HEIGHT / 2);
        }
        return targetYPos;
    }

    public getChestWinAnimation(multiplier:number, valueToAdd:number):TimelineLite {
        const pumpValueToAdd:number = valueToAdd / (multiplier - 1);
        const chestWinTL:TimelineLite = new TimelineLite();
        let chestCenterDelay:number = 0;
        if(pumpValueToAdd > BonusBunniesGameModuleConfig.bonusBunniesBonusMultiplierWPView.currentMultiplierValue) {
            chestWinTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusMultiplierWPView.setText(pumpValueToAdd, pumpValueToAdd));
            chestCenterDelay = 0.5;
        }
        chestWinTL.add([
            () => this._chestInfoLandscapeContainer.visible = false,
            () => this._chestInfoPortraitContainer.visible = false,
            () => this._chestAnimationActivated = true,
            () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_CHEST_SWEEP),
            new TweenLite(this._chestContainer.position, 0.5, {
                x : this.getChestTargetXPosition(),
                y : this.getChestTargetYPosition()
            }),
            new TweenLite(this._chestContainer.scale, 0.5, {x : 1, y : 1})
        ], "+=" + chestCenterDelay);
        chestWinTL.add(() => this._chestAnimation.skeleton.setSkin(null));
        chestWinTL.add(() => this._chestAnimation.skeleton.setSkinByName("x" + multiplier));//multiplier
        chestWinTL.add(() => this._chestAnimation.skeleton.setSlotsToSetupPose());
        chestWinTL.add([
            () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_CHEST_OPEN),
            () => this._chestAnimation.state.setAnimation(0, "open", false)
        ]);
        chestWinTL.add(() => this._chestAnimation.skeleton.setSkin(null), "+=2.2");
        chestWinTL.add(() => this._chestAnimation.skeleton.setSkinByName("x" + multiplier));//multiplier
        chestWinTL.add(() => this._chestAnimation.skeleton.setSlotsToSetupPose());
        let delay = 0;
        for(let i:number = 0; i < multiplier; i++) {
            if(i > 0) {
                delay = 0.6;
            }
            chestWinTL.add(() => this._chestAnimation.state.setAnimation(0, "pump", false), "+=" + delay);
            chestWinTL.add(() => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_CHEST_MULTIPLIER), "-=0.3");
            if(i == 0) {
                chestWinTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusMultiplierWPView.setTextChestPump(BonusBunniesGameModuleConfig.bonusBunniesBonusMultiplierWPView.currentMultiplierValue), "+=0.3");
            } else {
                chestWinTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusMultiplierWPView.setTextChestPump(BonusBunniesGameModuleConfig.bonusBunniesBonusMultiplierWPView.currentMultiplierValue + pumpValueToAdd), "+=0.3");
            }
        }

        return chestWinTL;
    }

    public enableChest():void {
        if(this._chestAnimation) {
            this._chestAnimation.skeleton.setSkin(null);
            this._chestAnimation.skeleton.setSkinByName("default");
            this._chestAnimation.skeleton.setSlotsToSetupPose();
            this._chestAnimation.state.setAnimation(0, "base", true);
        }
        this.setChestPosition(this._orientation);
        this._chestContainer.scale.set(0.5, 0.5);
        this._chestContainer.visible = true;
        this._chestAnimationActivated = false;
        this.onResize(this._resizeData);
    }

    public disableChest():void {
        this._chestContainer.visible = false;
    }

    private setChestPosition(orientation:string):void {
        if(orientation == Orientation.LANDSCAPE) {
            this._chestInfoLandscapeContainer.visible = true;
            this._chestInfoPortraitContainer.visible = false;
            this._chestContainer.position = BonusBunniesBonusSpinsChestView.CHEST_CONTAINER_LANDSCAPE_POSITION;
        } else {
            this._chestInfoLandscapeContainer.visible = false;
            //Dont show if there´s no room (4:3 portrait)
            if((this._resizeData.height - 720) / 2 > 200) {
                this._chestInfoPortraitContainer.visible = true;
            } else {
                this._chestInfoPortraitContainer.visible = false;
            }

            this._chestContainer.position = BonusBunniesBonusSpinsChestView.CHEST_CONTAINER_PORTRAIT_POSITION;
        }
        if(this._extraReelActivated == true) {
            this._chestContainer.position.x += BonusBunniesBonusSpinsChestView.CHEST_CONTAINER_EXTRA_REEL_OFFSET;
        }
    }

    set extraReelActivated(value:boolean) {
        if(value == true && this._extraReelActivated == false) {
            this._chestContainer.position.x += BonusBunniesBonusSpinsChestView.CHEST_CONTAINER_EXTRA_REEL_OFFSET;
        }
        this._extraReelActivated = value;
    }

    set extraRowActivated(value:boolean) {
        this._extraRowActivated = value;
    }
}